import React from 'react';
import { useGetBrand } from 'src/feature-app/hooks';
import { FormDataGroup, FormInfo, Steps } from 'src/types';
import { LeadGenericoComercialesForm } from './LeadGenericoComercialesForm';
import { LeadGenericoForm } from './LeadGenericoForm';

export interface LeadGenericoFormProps {
	steps: Steps[];
	leadData: Partial<FormDataGroup>;
	leadInfo: Partial<FormInfo>;
	firstStep: Steps;
	lastStep: Steps;
	inPage?: boolean;
	isConfigurador?: boolean;
	isVO?: boolean;
}

export const LeadGenericoController = (props: LeadGenericoFormProps) => {
	const brand = useGetBrand();

	return brand === 'V' ? (
		<LeadGenericoForm {...props} />
	) : brand === 'N' ? (
		<LeadGenericoComercialesForm {...props} />
	) : null;
};
